import { connect, Field as FormikField } from 'formik'
import { useTranslation } from 'react-i18next'
import { formFieldNames } from '@/entity'
import React, { useCallback, useEffect } from 'react'
import { Field } from '@/ui'

export const DistrictField = connect(
	({ disabled, options = [], formik: { setFieldValue, values }, loadRegions, isFormDirty, refreshLocalities }) => {
		const { t } = useTranslation()

		return (
			<FormikField name={formFieldNames.districtWork}>
				{({ field, meta: { touched, error } }) => {
					useEffect(() => loadRegions(field.value), [field.value])

					const onChange = useCallback((code) => {
						setFieldValue(formFieldNames.districtWork, code)
						setFieldValue(formFieldNames.regionWork, null)
						setFieldValue(formFieldNames.locality, null)
						refreshLocalities()
					}, [])

					return (
						<Field
							type="text"
							fieldType="select"
							label={t('contracts_tab.region_work')}
							placeholder={t('choose_from_handbook')}
							options={options}
							error={(touched || isFormDirty) && error}
							disabled={values[formFieldNames.countryWork] !== '398' || disabled} // Не активно, если выбрана страна не Казахстан
							isRequired={values[formFieldNames.countryWork] === '398'} // Обязательное, если страна Казахстан
							{...field}
							onChange={onChange}
						/>
					)
				}}
			</FormikField>
		)
	}
)
